import styles from './FieldError.module.css';

export interface FieldErrorProps {
  children: any;
  style?: React.CSSProperties;
}

export const FieldError = ({ children, style }: FieldErrorProps) => (
  <div className={styles.error} style={style}>
    {children}
  </div>
);
